import React from 'react';
import ReactDOM from 'react-dom';
import CollectionPage from 'Collection/CollectionPage';

const collectionJson = JSON.parse(document.getElementById("collectionPageJson").textContent); // eslint-disable-next-line
const salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line
const breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
ReactDOM.render(<CollectionPage {...collectionJson.Model} salonCountries={salonCountries} breadcrumbs={breadcrumbs} />, document.getElementById("collectionPage"));
